import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoyalty = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2.66675 19.0708H6.77178C8.13268 19.0708 9.43784 19.6115 10.4001 20.5738C11.3624 21.5361 11.9031 22.8412 11.9031 24.2021",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.74552 24.2022H16.0081C17.0968 24.2022 18.1409 24.6347 18.9108 25.4045C19.6806 26.1744 20.1131 27.2185 20.1131 28.3072C20.1131 28.5794 20.005 28.8404 19.8125 29.0329C19.6201 29.2254 19.359 29.3335 19.0869 29.3335H2.66675",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5999 19.0708L11.3899 11.4765C6.91538 6.9815 13.4424 -1.72117 19.5999 5.31896C25.7575 -1.70064 32.346 7.00202 27.81 11.4765L19.5999 19.0708Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLoyalty);
export default ForwardRef;
